export const TRADING_CONSTANTS = {
  INITIAL_BALANCE: 100_000,
  MIN_ORDER_SIZE: 0.001,
  MAX_LEVERAGE: 50,
  DEFAULT_LEVERAGE: 10,
  MAKER_FEE: 0.0002, // 0.02%
  TAKER_FEE: 0.0005, // 0.05%
  MAINTENANCE_MARGIN: 0.05, // 5%
  LIQUIDATION_THRESHOLD: 0.8, // 80% of maintenance margin
} as const;

export const UI_CONSTANTS = {
  ORDERBOOK_LEVELS: 10,
  RECENT_TRADES_LIMIT: 50,
  PARTICIPANTS_DEFAULT_VISIBLE: 10,
  LEADERBOARD_PAGE_SIZE: 20,
  CHART_CANDLE_LIMIT: 500,
  WS_RECONNECT_DELAY: 3000,
  WS_HEARTBEAT_INTERVAL: 30000,
} as const;

export const STRESS_TEST_CONFIG = {
  SLOW_TPS: 10,
  MEDIUM_TPS: 100,
  FAST_TPS: 500,
} as const;
